import React from 'react'
import { t } from 'i18next'
import ErrorForModal, { ErrorForModalProps } from 'src/components/Atoms/ErrorForModal/ErrorForModal'
import updateModal from 'src/components/Sections/Modal/updateModal'

type CallModalFunction = (
  response?: ErrorForModalProps['response'],
  redirect?: ErrorForModalProps['redirect'],
  ws?: ErrorForModalProps['ws']) => void

const callModal: CallModalFunction = (response?: Response, redirect?: boolean, ws?: string) => {
  updateModal({
    title: t('error.anErrorHasOcurred'),
    modalState: 'open',
    content: <ErrorForModal response={response} redirect={redirect} ws={ws} />,
    removeFooter: true,
    removeHeader: true,
    headerBgColor: 'warning',
  })
}

export { callModal }
